<template>
  <v-container fluid>
    <Submenu v-bind:title="'Groups'"
      v-bind:showSearch="true"
      v-on:search="search_change"
      />

    <v-btn absolute fab :right="!isRtl" :left="isRtl"
    color="primary" class="mx-6 mt-n2" @click.stop="showDialog=true" :key="groupKey">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <AddEditGroupDialog v-bind:value.sync="showDialog" v-bind:groupId="undefined" v-on:close="close" />
    <v-layout wrap>
      <v-flex mb-4 mr-2 xs12 sm6 md4 xl2 v-for="g in groups" v-bind:key=g.Id>
        <GroupPanel  v-bind:groupId="g.Id" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AddEditGroupDialog from "../components/AddEditGroup";
import GroupPanel from "../components/GroupPanel";
import Submenu from "../components/common/submenu";

export default {
  data: function()  {
    return {
      showDialog: false,
      groupKey: 0,
      search: ''
    }
  },
  components: {
    AddEditGroupDialog,
    GroupPanel,
    Submenu
   },
  computed: {
    groups() {
      return this.$store.getters.getGroupsSearch(this.search);
    },
    isRtl: function() {
      //make drawer on right for he locale
      return this.$i18n.locale == "he";
    }
  },
  methods: {
    search_change(event) {
      this.search = event;
    },
    close() {
      this.groupKey++;
      this.showDialog=false;
    }
  },
}
</script>
